import React from "react";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
// import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
// import Avatar from "@material-ui/core/Avatar/Avatar";
// import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton/IconButton";
// import Modal from "@material-ui/core/Modal";
// import FolderIcon from "@material-ui/icons/Folder";
import DeleteIcon from "@material-ui/icons/Delete";
import LazyLoad from "react-lazy-load";
import _ from "lodash";

export default ({ Files, AddDeleteAttach, UserId }) => (
  <div className="list_attach_fils">
    {_.map(Files, (file) => {
      return (
        <div
          className={
            parseInt(UserId) === parseInt(file["user_id"])
              ? "item_attach me"
              : "item_attach"
          }
        >
          <div className="header_attach">
            <span>
              {parseInt(UserId) === parseInt(file["user_id"])
                ? "ثبت شده توسط شما"
                : "ثبت شده توسط بیمار"}
            </span>{" "}
            <time>{file["jalali_created_at"]}</time>
          </div>
          <div className="main_attach">
            <p>{file["message"]}</p>
          </div>

          <List dense={false}>
            <ListItem className="item_at_file">
              {file["file"] ? (
                <a
                  href={file["file"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LazyLoad height={220} offsetVertical={220}>
                    <img
                      style={{ width: 200, height: 200, borderRadius: 8 }}
                      src={file["file"]}
                      alt="preview-file"
                    />
                  </LazyLoad>
                </a>
              ) : null}

              {parseInt(UserId) === parseInt(file["user_id"]) ? (
                <ListItemSecondaryAction
                  className="delete_at_file"
                  onClick={(e) => AddDeleteAttach(file["key"])}
                >
                  <IconButton aria-label="Delete">
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              ) : null}
            </ListItem>
          </List>
        </div>
      );
    })}

    <div className="alert alert-info">
      در صورتیکه که نیاز به ثبت مستندات جدید دارید بر روی + بزنید . در غیر
      اینصورت پنجره را ببندید.
    </div>

    <div id="list_attach_fils" />
  </div>
);
